import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
  Button,
  useToast,
  Switch,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import OperationLocationAPI from 'api/operationlocation';

const validationSchema = Yup.object({
  name: Yup.string().trim().required('Location name is required'),
  displayOrder: Yup.number()
    .positive('Display order must be positive')
    .integer('Display order must be an integer')
    .required('Display order is required'),
});

export default function PopModal(props) {
  const toastIdRef = React.useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [name, setName] = useState();
  const [displayOrder, setDisplayOrder] = useState(1);
  const [isactive, setisactive] = useState(true);
  const toast = useToast();
  const [response, setResponse] = useState();
  const [error, setError] = useState(false);
  const add = async (e) => {
    e.preventDefault();

    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }

    if (!name) {
      toastIdRef.current = toast({
        title: 'All fields are required',
        status: 'error',
        duration: 1000,
        isClosable: true,
        position: 'top',
      });
    } else {
      try {
        const api = await OperationLocationAPI.Create({
          name,
          display_order: Number(displayOrder),
          isactive,
        });
        setResponse(api.data);
        if (api.data.status_code === 200) {
          toastIdRef.current = toast({
            title: api?.data?.message || 'Successfully Added',
            status: 'success',
            duration: 1000,
            isClosable: true,
            position: 'top',
          });
          onClose();
          props.func();
        } else if (api.data.status_code !== 200) {
          toastIdRef.current = toast({
            title: api?.data?.message,
            status: 'error',
            duration: 1000,
            isClosable: true,
            position: 'top',
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      displayOrder: 1,
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const api = await OperationLocationAPI.Create({
          name: values.name,
          display_order: Number(values.displayOrder),
          is_active: isactive,
        });

        if (api.data.status_code === 200) {
          toast({
            title: 'Successfully Added',
            description: api.data.message,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top',
          });
          onClose();
          resetForm();
          props.func();
        } else {
          throw new Error(api.data.message);
        }
      } catch (error) {
        toast({
          title: 'Failed to add location',
          description: error.message || 'Unknown error',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      <Button
        variant='lightBrand'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        py='5px'
        onClick={onOpen}
        disabled={props.disabled}
      >
        {props.Icon}
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        initialFocusRef={formik.initialRef}
        finalFocusRef={formik.finalRef}
      >
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={formik.handleSubmit}>
            <ModalHeader>{props.head}</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl
                isInvalid={formik.touched.name && formik.errors.name}
              >
                <FormLabel>Location Name *</FormLabel>
                <Input
                  variant='auth'
                  placeholder='location name'
                  {...formik.getFieldProps('name')}
                />
                {formik.touched.name && formik.errors.name ? (
                  <Text color='red.400'>{formik.errors.name}</Text>
                ) : null}
              </FormControl>

              <FormControl
                mt={4}
                isInvalid={
                  formik.touched.displayOrder && formik.errors.displayOrder
                }
              >
                <FormLabel>Display Order *</FormLabel>
                <Input
                  variant='auth'
                  type='number'
                  placeholder='display order'
                  {...formik.getFieldProps('displayOrder')}
                />
                {formik.touched.displayOrder && formik.errors.displayOrder ? (
                  <Text color='red.400'>{formik.errors.displayOrder}</Text>
                ) : null}
              </FormControl>

              <FormControl display='flex' alignItems='center' mt={4}>
                <FormLabel htmlFor='email-alerts' mb='0'>
                  Is Active?
                </FormLabel>
                <Switch
                  id='active-filter'
                  isChecked={isactive}
                  onChange={(e) => setisactive(e.target.checked)}
                />
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme='blue'
                mr={3}
                type='submit'
                disabled={!formik.isValid || formik.isSubmitting}
              >
                Save
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}
